import { useEffect } from 'react';
import { Client } from '../../../../prismic1';
import Prismic from 'prismic-javascript';
import { useLayout } from '../../../../utils/layout-context';
import { getLanguage } from '../../../../lib/getLanguage';
import Head from '../../../../components/Head';
import { getBlogsCategoryPaths } from '../../../../services/pagination/getBlogsPathsCategory';
import AllBlogsInCategory from '../../../../components/AllBlogsInCategory';
import { fetchAllPaginatedPrismicData } from '../../../../utils/fetchAllPaginatedPrismicData';

const BlogTopicCategory = (props) => {
  const {
    blogsForCategoryPagginated,
    allBlogsBasedOnTopic,
    all_blog_categories,
    params,
    blogCategoryData,
  } = props;
  const { setHeaderColor } = useLayout();

  useEffect(() => {
    setHeaderColor(true);
  }, []);
  return (
    <>
      <Head
        data={blogCategoryData.data}
        canonical={`/blog/topic/${params.category}/${params.idx}`}
      />
      <AllBlogsInCategory
        allBlogs={blogsForCategoryPagginated}
        blogCategoryData={blogCategoryData}
        allBlogsBasedOnTopic={allBlogsBasedOnTopic}
        allBlogCategories={all_blog_categories}
        params={params}
      />
    </>
  );
};

export const queryParams = {
  fetchLinks: [],
};

export async function getStaticProps({
  preview = null,
  previewData = {},
  params,
  locale,
}) {
  //if the id parameter is not a whole number, return the 404 error page
  if (!params.idx || isNaN(params.idx) || params.idx % 1 !== 0) {
    return errorService.notFoundResponse;
  }

  const client = Client();
  const languageObject = getLanguage(locale);
  const language = await languageObject.prismicLanguage.toLowerCase();

  let hasNextPage = true;

  const allBlogs = await fetchAllPaginatedPrismicData(
    [
      Prismic.Predicates.at('document.type', 'blog_post'),
      Prismic.Predicates.has('my.blog_post.date'),
    ],
    {
      lang: language,
      fetchLinks: ['project_category.title', 'blog_topic.topic_name'],
      orderings: '[my.blog_post.date desc]',
    }
  );

  const allBlogsBasedOnTopic = allBlogs.filter((blog, i) => {
    return blog.data.blog_topics.find((blogTopic, idx) => {
      return blogTopic.blog_topic.uid == params.category;
    });
  });

  const blogsForCategoryPagginated = allBlogsBasedOnTopic.slice(
    params.idx == 1 ? 0 : (params.idx - 1) * 25,
    +params.idx * 25
  );

  const all_blog_categories = await client.query(
    Prismic.Predicates.at('document.type', 'blog_topic'),
    {
      lang: language,
    }
  );

  const blogCategoryData = await client.getByUID(
    'blog_topic',
    params.category,
    { lang: language }
  );
  return {
    props: {
      params,
      allBlogsBasedOnTopic,
      all_blog_categories,
      blogsForCategoryPagginated,
      blogCategoryData,
    },
  };
}

export async function getStaticPaths() {
  const client = Client();
  const paths = await getBlogsCategoryPaths();
  return {
    paths,
    fallback: 'blocking',
  };
}
export default BlogTopicCategory;
